const GTM_CONTAINER_ID_PATTERN = /^GTM-[A-Z0-9]+$/;
const GTM_ENV_PARAM_PATTERN = /^(?:gtm_auth|gtm_preview|gtm_cookies_win)=[A-Za-z0-9_.~-]*$/;

const splitGtmKey = (gtmKey: string): { containerId: string; envParams: string[] } => {
  const [containerId, ...envParams] = gtmKey.split('&');
  return { containerId, envParams };
};

export const isValidGtmKey = (gtmKey: string | undefined): gtmKey is string => {
  if (!gtmKey) return false;
  const { containerId, envParams } = splitGtmKey(gtmKey);
  return GTM_CONTAINER_ID_PATTERN.test(containerId) && envParams.every((param) => GTM_ENV_PARAM_PATTERN.test(param));
};

export const normalizeGtmKey = (gtmKey: string | undefined): string | undefined => {
  const trimmed = gtmKey?.trim();
  if (!trimmed) return undefined;
  const { containerId, envParams } = splitGtmKey(trimmed);
  return [containerId.toUpperCase(), ...envParams].join('&');
};
